<template>
    <div class="mywrap">

        <div v-for="(attrItem, attrIndex) in menuList" :key="attrIndex">
            <div class="flex-1 oa-attr min-w-0" v-show="attrIndex === menuIndex">
                <div class="text-base oa-attr-title"
                    style="display: flex; align-items: center;justify-content: space-between;">
                    <div>菜单配置</div>
                    <div @click="handleDelMenu(menuIndex)">
                        <i class="el-icon-circle-close"></i>
                    </div>
                </div>

                <div >
                    <div class="flex items-center w-full p-4 mt-4 rounded bg-fill-light">
                        <OaMenuForm ref="menuRef" modular="master" :menuForm="attrItem">
                            <div class="flex-1">
                                <!-- 编辑子菜单 -->
                                <ul>
                                    <li class="flex" v-for="(subItem, subIndex) in attrItem.sub_button" :key="subIndex"
                                        style="padding: 8px">
                                        <span class="mr-auto">{{ subItem.name }}</span>
                                        <!-- 编辑子菜单 -->
                                        <OaMenuFormEdit modular="edit" :subItem="subItem"
                                            @edit="handleEditSubMenu($event, subIndex)">
                                            <el-button link>
                                                <el-icon>
                                                    <EditPen />
                                                </el-icon>
                                            </el-button>
                                        </OaMenuFormEdit>

                                        <!-- 删除子菜单 -->
                                        <popup @confirm="handleDelSubMenu(menuIndex, subIndex)">
                                            是否删除当前子菜单？
                                            <template #trigger>
                                                <el-button link>
                                                    <el-icon class="ml-5">
                                                        <Delete />
                                                    </el-icon>
                                                </el-button>
                                            </template>
                                        </popup>
                                    </li>
                                </ul>

                                <!-- 新增子菜单 -->
                                <OaMenuFormEdit :modular.sync="add" :dialogVisible.sync="dialogVisible">
                                    <el-button type="primary" link :disabled="attrItem.sub_button.length >= 5" @click="handleAddSubMenu" >
                                        添加子菜单({{ attrItem.sub_button.length }}/5)
                                    </el-button>
                                </OaMenuFormEdit>
                            </div>
                        </OaMenuForm>
                    </div>

                </div>
            </div>
        </div>
    </div>

</template>
<script>

import OaMenuFormEdit from './oa-menu-form-edit'
import OaMenuForm from './oa-menu-form'
export default {
    components: {
        OaMenuFormEdit,
        OaMenuForm
    },
    data() {
        return {
            dialogVisible:false,
            add:'add'
        }
    },
    props: {
        menuList: {
            type: Array,
            default: function () {
                return []
            }
        },
        menuIndex: {
            type: Number,
            default: 0
        }

    },
    watch: {
        menuList() {
            this.init()
        },
    },
    created() {

    },

    methods: {
        init() {
            console.log(this.menuList, 9090123)

        },
        handleAddMenu() {
            this.menuList.push({
                name: '菜单名称',
                has_menu: false,
                type: 'view',
                url: '',
                appid: '',
                pagepath: '',
                sub_button: []
            })
        },
        handleAddSubMenu(e) {
            const index = this.menuIndex
            if (this.menuList[index].sub_button.length >= 5) {
                console.log('已添加上限～')
                return
            }
            this.menuList[index].sub_button.push(e)
        },
        handleDelMenu(index) {
            if (index != 0) {
                this.menuIndex--
            }
            this.menuList.splice(index, 1)
        }

    }

};
</script>
<style lang="scss">
.flex {
    display: flex;
}

.items-center {
    align-items: center;
}

.justify-center {
    justify-content: center;
}

.flex-1 {
    flex: 1 1 0%；
}

.text-sm {
    font-size: 13px;
}

.text-base {
    font-size: 14px;
}

.mt-4 {
    margin-top: 20px
}

.p-4 {
    padding: 20px;
}

.mywrap {
    background: #f8f8f8;
    padding: 20px
}
</style>



// WEBPACK FOOTER //
// src/views/appsetting/appmp/menu_com/oa-attr copy.vue